import { useContext } from 'react';
import { globalContext } from '~/context';

const useGlobalContext = () => {
  const [state, dispatch] = useContext(globalContext);

  return {
    state,
    dispatch
  };
};

export default useGlobalContext;